<!-- <div class="menu">
    <span class="menu-heading">Upload</span>
    <span class="close" (click)="closeAddDocumentPopup()">X</span>
</div> -->

<!-- <div class="row console p0 m0">
        <div class="upload">
            <form> -->
                <app-file-uploader
                    title="Upload Documents"
                    (handleCancel)="handleCancel($event)"
                    (handleFileUpload)="handleFileUpload($event)"
                    [allowedFileTypes]="allowedFileTypes"
                    [maxFileSize]="maxFileSize"
                ></app-file-uploader>
            <!-- </form>
        </div>
</div> -->

<!-- <div class="menu-bottom text-center">
    <button class="main-btn large" (click)="uploadFile()">Upload</button>
    <button class="outline-btn large ms-2" (click)="closeAddDocumentPopup()">Cancel</button>
</div> -->